import Animation from './animation'

/*
 * This animation is used when a new `line` type serie
 * is being added to the chart
 */
class EnteringAnimation extends Animation {

  match (serie) {
    return this.seriesChanged &&
           this.previous.series.data().indexOf(serie) === -1 // We didn't have this serie previously
  }

  animate (serie, entering, selection, merged, exiting) {
    this._initialInsert(entering) // Get the elements in the DOM
    this._walkLine(entering, exiting, this._growPath)
  }

}

export default EnteringAnimation
